import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { WorkshopPack, type LogistikProduct } from '@chancenwerk/db/LogistikProduct.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { AddResult, NoneResult } from '../../helpers/order-amount-range.js';

/**
 * @customElement logistik-dialog-disallowed-order-change
 */
@customElement('logistik-dialog-disallowed-order-change')
export class LogistikDialogDisallowedOrderChange extends ChromiumDialog<boolean> {
  static override get element_name() {
    return 'logistik-dialog-disallowed-order-change';
  }

  override heading?: string | undefined = 'Unerlaubte Warenkorbänderung';

  @property() public allowedChange!: AddResult | NoneResult;
  @property() public product!: LogistikProduct;

  override content() {
    return html` <cr-text> Die von Ihnen angegebene Anzahl kann nicht zum Warenkorb hinzugefügt werden. </cr-text> `;
  }

  override headingContent() {
    const title = (() => {
      if (this.allowedChange.type === 'add' && this.allowedChange.quantity > 0) {
        const isWorkshop = this.product instanceof WorkshopPack;
        if (isWorkshop) {
          if (this.allowedChange.lower) {
            return `Maximale Anzahl der Teilnehmenden wurde nicht eingehalten`;
          } else {
            return `Minimale Anzahl der Teilnehmenden wurde nicht eingehalten`;
          }
        } else {
          if (this.allowedChange.lower) {
            return `Maximale Bestellmenge wurde nicht eingehalten`;
          } else {
            return `Minimale Bestellmenge wurde nicht eingehalten`;
          }
        }
      }
      return `Maximal-Anzahl von Produkten erreicht`;
    })();
    return html`
      <cr-h3> ${title} </cr-h3>
      <cr-button ${css({ color: this.colors.tone.error })} big mode="icon" icon="close" @click=${() => this.cancel()}>
      </cr-button>
    `;
  }

  override footerContent(): Renderable {
    return html`
      <cr-flex horizontal end space="sm">
        ${this.allowedChange.type === 'add' && this.allowedChange.quantity > 0
          ? html`
              <cr-button @click=${() => this.resolve(false)}> Abbrechen </cr-button>
              <cr-button @click=${() => this.resolve(true)}> ${this.allowedChange.quantity} Bestellen</cr-button>
            `
          : html` <cr-button @click=${() => this.resolve(false)}> Schließen </cr-button> `}
      </cr-flex>
    `;
  }
}
